import { Button, Col, Dropdown, MenuProps, notification, Row, Tag } from 'antd';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfAchivementsContext,
  UserAchievementsDataContext,
} from '../../../../../../../context';
import DeleteModal from '../../../../../modal/delete';
import EditAchievement from '../edit-achievement';
import styles from './styles.module.scss';

interface AchievementDetailProps {
  achievement_id: number;
  title: string;
  description: string;
  url: string;
  score: string;
  show_in_resume: boolean;
}

const AchievementDetail: React.FC<AchievementDetailProps> = ({
  achievement_id,
  title,
  description,
  url,
  score,
  show_in_resume,
}: AchievementDetailProps): JSX.Element => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const { setUserAchievementsData } = useContext(UserAchievementsDataContext);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { setNumberOfAchievements } = useContext(NumberOfAchivementsContext);

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error',
    title: string
  ) => {
    notification[notificationType]({
      message:
        notificationType === 'info'
          ? `Deleting Achievement ${title}`
          : notificationType === 'success'
          ? `Deleted Achievement ${title} Successfully`
          : notificationType === 'error'
          ? `An error occurred while deleting achievement ${title}`
          : '',
    });
  };

  const handleDelete = () => {
    openNotification('info', title);
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/achievements';
      reqBody = { profile_id: employeeId, achievement_id, status: 3 };
    } else {
      url = '/api/v1/profile/achievements';
      reqBody = { achievement_id, status: 3 };
    }
    axiosInstance
      .post(url, reqBody)
      .then((response) => {
        let userAchievements: Array<any> = [];
        if (response.data.achievements.length !== 0) {
          userAchievements = response.data.achievements.filter(
            (Achievement: any) => Achievement['status']['id'] === 1
          );
          // const orderedAchievements = response.data.achievements.map((achievementId: number) =>
          //   userAchievements.find((userAchievement: any) => userAchievement.achievement_id === achievementId)
          // ).filter((item: any) => item !== undefined);
          setUserAchievementsData(userAchievements);
        } else {
          setUserAchievementsData(response.data.achievements);
        }
        setNumberOfAchievements(userAchievements.length);
        openNotification('success', title);
      })
      .catch((error) => {
        console.log(error);
        openNotification('error', title);
      });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {isEditable ? (
        <EditAchievement
          {...{
            achievement_id,
            title,
            description,
            url,
            score,
            setIsEditable,
            show_in_resume,
          }}
        />
      ) : (
        <Row
          key={achievement_id}
          className={styles.row}
          gutter={{ xs: 8, sm: 16 }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              position: 'absolute',
              bottom: '5px',
              right: '5px',
            }}
          >
            {show_in_resume ? (
              <Tag color="success">Show in resume: Yes</Tag>
            ) : (
              <Tag color="error">Show in resume: No</Tag>
            )}
          </div>
          <Col span={12}>
            <Row>
              <h3 className={styles['Achievement-text']}>
                <b>{title}</b>
              </h3>
            </Row>
            <Row>
              <p>{description}</p>
            </Row>
          </Col>
          <Col span={11}>
            {score && (
              <Row>
                <Col span={12}>
                  <p>
                    <span>Score : </span>
                    <span>{score}</span>
                  </p>
                </Col>
              </Row>
            )}
            {url && url.length && (
              <Row>
                <p>
                  <span>URL : </span>
                  <span>{url}</span>
                </p>
              </Row>
            )}
          </Col>
          <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
                top: '10px',
              }}
            >
              <img
                src="/more_vert.png"
                style={{
                  marginLeft: 'auto',
                  marginRight: '0px',
                  height: '15px',
                  width: '5px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Dropdown>
        </Row>
      )}
    </div>
  );
};

export default AchievementDetail;
